import { Address } from './types';

export const tranformAdrressesToForm = (addresses: string[]) =>
  addresses.map((address) => ({ address }));

export const tranformAdrresses = (addresses: Address[]) => {
  return addresses.map(({ address }) => address);
};
